import { PatientBase, PatientModelBase } from 'core/models/patientModelBase';
import { Patient, PatientModel, RawPatient } from 'core/models/patientModel';

// eslint-disable-next-line no-shadow
export enum SensorEnum {
  ECG = 'ECG',
  SpO2 = 'SpO2',
  BP = 'BP',
  Weight = 'Weight',
  Temperature = 'Temperature',
  Watch = 'Watch',
  WeightScale = 'Weight Scale',
  HR = 'HR',
  HRV = 'HRV',
  RR = 'RR',
  Activity = 'Activity',
  CGM = 'CGM',
  EcgEventCount = 'ECGEventCount',
  AfibAndPvcAndPacCount = 'AfibAndPvcAndPacCount',
  SLEEP = 'Sleep',
  STEP = 'Step',
  FALL = 'Fall',
}

export interface SortData {
  order?: string;
  desc?: boolean;
}

export interface SensorSortData {
  key: string;
  order: string;
  sortType: 'ascend' | 'descend' | null;
}

export interface SensorType {
  id: string;
  code: number;
  name: string;
}

export interface Sensor {
  id: string;
  identifier: string;
  patient?: Patient;
  device?: Device;
  siteId?: string;
  siteName?: string;
  name?: string;
  type?: string;
  createdAt?: string;
  kitId?: string;
}

export interface DeviceSimple {
  id: string;
  name: string;
  uniqueId: string;
}

export interface Device {
  id: string;
  uniqueId?: string;
  identifier?: string;
  patient?: Patient;
  device?: Device;
  siteId?: string;
  siteName?: string;
  name?: string;
  type?: string;
  createdAt?: string;
  kitId?: string;
}

export interface PatientDevices {
  deviceId: string;
  siteId?: string;
  deviceName?: string;
  deviceTypeName?: PatientBase;
  note?: string;
  sessionId?: string;
  createdAt?: string;
  kitId?: string;
}

export interface RawDevice {
  id: string;
  identifier: string;
  patient?: RawPatient;
  siteId?: string;
  siteName?: string;
  type?: string;
  typeName?: string;
  time?: string;
  note?: string;
  sessionId?: string;
  createdAt?: string;
  kitId?: string;
}

export const DEVICE_TITLE = 'Device';

export class DeviceModel implements Device {
  id: string;

  identifier: string;

  patient?: Patient;

  siteId?: string;

  siteName?: string;

  type?: string;

  note?: string;

  sessionId?: string;

  createdAt?: string;

  kitId?: string;

  constructor(data: RawDevice) {
    this.id = data.id;
    this.identifier = data.identifier;
    if (typeof data.patient === 'string') {
      throw Error('RawDevice not populated');
    } else {
      this.patient = data.patient && new PatientModel(data.patient);
    }
    this.siteId = data.siteId;
    this.siteName = data.siteName;
    this.type = data.type;
    this.note = data.note;
    this.sessionId = data.sessionId;
    this.createdAt = data.createdAt;
    this.kitId = data.kitId;
  }
}

export interface DeviceFormData {
  identifier: string;
  type?: string | number;
  site?: string;
}

export interface SensorFormData {
  identifier: string;
  type?: string | number;
}
